module.exports = __webpack_public_path__ + "img/enlightenment-course-5.660e1c1b.png";